interface FeedbackRequest {
  message_id: string;
  feedback_type: 'thumbs_up' | 'thumbs_down' | 'need_review';
  reason?: string;
  additional_comments?: string;
  client_id?: string;
  conversation_id?: string;
  metadata?: any;
}

interface FeedbackResponse {
  status: string;
  message: string;
  message_id: string;
}

class FeedbackService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  }

  async submitFeedback(feedback: FeedbackRequest): Promise<FeedbackResponse> {
    try {
      // Prepare headers
      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
      };

      // Add authentication for internal users
      const authToken = localStorage.getItem('auth_token');
      if (authToken) {
        headers['Authorization'] = `Bearer ${authToken}`;
      }

      const response = await fetch(`${this.baseUrl}/api/feedback`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...feedback,
          metadata: {
            guest_token: localStorage.getItem('guest_token') || undefined,
            ...feedback.metadata  // Preserve any additional metadata passed in
          }
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  }

  async getFeedbackStats(clientId: string) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${this.baseUrl}/api/feedback/${clientId}/stats`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting feedback stats:', error);
      throw error;
    }
  }

  async getMessagesWithFeedback(clientId: string) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${this.baseUrl}/api/feedback/${clientId}/messages`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting messages with feedback:', error);
      throw error;
    }
  }
}

export const feedbackService = new FeedbackService();
export default feedbackService;